import { devLog } from "../../utils/devLog";
import {
  LOAD_PATIENTS,
  LOAD_PATIENT,
  PATIENT_ADD,
  PATIENTS_RESET_LOADING,
  PATIENTS_LOADED,
  SET_PATIENTS_FILTER,
  PATIENTS_RESET_TO_MODE,
  SET_ACTIVE_PATIENT,
  ADD_TO_FILTER_FROM_DASHBOARD,
  REFRESH_PATIENTS,
  REFRESH_PATIENTS_AND_RESET_PAGE,
  LOAD_SAVED_SEARCHES,
  SET_EDIT_PATIENT_CP,
  UPDATE_PATIENT_IN_LIST,
  REMOVE_PATIENT_FROM_LIST,
  ADD_PATIENT_TO_LIST,
  NAVIGATE_TO_ALL_PATIENTS,
  NAVIGATE_TO_WATCHLIST,
  NAVIGATE_TO_MY_PATIENTS,
  NAVIGATE_TO_SAVED_QUERY,
} from "./actionTypes";

export function onLoadPatient(id) {
  return { type: LOAD_PATIENT, id };
}

export function onLoadPatients(searchCriteria) {
  //devLog("[onLoadPatients] Action creator called with:", {
  //  hasSearchCriteria: !!searchCriteria,
  //  searchCriteria: searchCriteria,
  //  hasQueryId: !!searchCriteria?.queryId,
  //  queryIdValue: searchCriteria?.queryId,
  //  stackTrace: new Error().stack,
  //});
  return { type: LOAD_PATIENTS, searchCriteria };
}

export function onAddPatient(data) {
  return { type: PATIENT_ADD, data: data };
}

export function onResetLoading(criteria) {
  //devLog("[onResetLoading] Action creator called with:", {
  //  hasCriteria: !!criteria,
  //  criteria: criteria,
  //  hasQueryId: !!criteria?.queryId,
  //  queryIdValue: criteria?.queryId,
  //  stackTrace: new Error().stack,
  //});
  return { type: PATIENTS_RESET_LOADING, criteria };
}

export function onResetToMode(mode) {
  return { type: PATIENTS_RESET_TO_MODE, mode };
}

export function onSetFilter(filter, mode, staffId) {
  return { type: SET_PATIENTS_FILTER, filter, mode, staffId };
}

export function onSetActivePatient(patientId, criteria) {
  return { type: SET_ACTIVE_PATIENT, patientId, criteria };
}

export function onAddToPatientFilter(fields) {
  return { type: ADD_TO_FILTER_FROM_DASHBOARD, fields };
}

export function refreshListing() {
  return { type: REFRESH_PATIENTS };
}

export function refreshListingAndResetPage() {
  return { type: REFRESH_PATIENTS_AND_RESET_PAGE };
}

// Targeted navigation actions for different list types
export function navigateToAllPatients() {
  return { type: NAVIGATE_TO_ALL_PATIENTS };
}

export function navigateToWatchlist() {
  return { type: NAVIGATE_TO_WATCHLIST };
}

export function navigateToMyPatients() {
  return { type: NAVIGATE_TO_MY_PATIENTS };
}

export function navigateToSavedQuery(queryId, queryData) {
  return { type: NAVIGATE_TO_SAVED_QUERY, queryId, queryData };
}

export function onLoadSavedSearches() {
  return { type: LOAD_SAVED_SEARCHES };
}

export function setEditPatientCarePlan(data) {
  return { type: SET_EDIT_PATIENT_CP, data };
}

export function onUpdatePatientInList(patientId, updates) {
  return { type: UPDATE_PATIENT_IN_LIST, patientId, updates };
}

export function onRemovePatientFromList(patientId) {
  return { type: REMOVE_PATIENT_FROM_LIST, patientId };
}

export function onAddPatientToList(patient) {
  return { type: ADD_PATIENT_TO_LIST, patient };
}

export function onPatientsLoaded(list, page, loadMore, total, criteria) {
  return { type: PATIENTS_LOADED, list, page, loadMore, total, criteria };
}
